const RenderMode = {
  SERVER: 'server',
  CLIENT: 'client',
};

export default RenderMode;
